module.exports = __webpack_public_path__ + "static/media/vf-button-men-bag.ba06b631.svg";